import { writable } from 'svelte/store';
export const createSettingsStore = () => {
    const settingsState = {
        theme: 'light',
    };
    const { subscribe, update } = writable(settingsState);
    const toggleTheme = () => {
        update((settings) => (Object.assign(Object.assign({}, settings), { theme: settings.theme === 'light' ? 'dark' : 'light' })));
    };
    return { subscribe, toggleTheme };
};
